export default "__VITE_ASSET__DzNJ5AE5__"